import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';

// Same proportion the app uses for the grid card image: 140% of the width
// when portrait, square otherwise.
const PORTRAIT_RATIO = 1.4;
const DEFAULT_IMAGE_WIDTH = 175.5;

const useStyles = makeStyles(() => ({
  imageContainer: props =>({
    backgroundImage: `url(${props.imageUrl})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: props.resizeMode === 'fit' ? 'contain' : 'cover',
    height: props.imageShape === 'portrait' ? props.width * PORTRAIT_RATIO : props.width,
    overflow: "hidden",
    width: props.width
  })
}));

export default function ImageArea({ images, settings, width = DEFAULT_IMAGE_WIDTH }) {
  const imageUrl =
    _.isEmpty(images) ?
    require("../../../Editor/_assets/images/image_placeholder_350_350.png") :
    images[0].imageUrl;

  const classes = useStyles({...settings, imageUrl: imageUrl, width: width });

  return (
    <div className={classes.imageContainer} />
  );
}
